import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Container,
  AppBar,
  Typography,
  Drawer,
  ListItemIcon,
  ListItem,
  Divider,
  ListItemText,
  List,
  Box,
  ListSubheader,
  Toolbar,
  Grid,
  IconButton,
} from "@material-ui/core"
import * as headerStyles from "./header.module.scss"

import HomeIcon from "@material-ui/icons/Home"
import MenuIcon from "@material-ui/icons/Menu"
import PostAddIcon from "@material-ui/icons/PostAdd"
import InfoIcon from "@material-ui/icons/Info"
import { useIntl, navigate } from "gatsby-plugin-intl"
import Language from "./lenguajes"

const Header = ({ siteTitle }) => {
  const intl = useIntl()
  const [anchor] = useState("left")
  const [state, setState] = useState({
    left: false,
  })

  const toggleDrawer = (anchor, open) => event => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }

    setState({ ...state, [anchor]: open })
  }

  const list = anchor => (
    <div
      className={headerStyles.drawerList}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            navigate("/")
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            {" "}
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "home" })} />
        </ListItem>
        <Divider />
        <ListSubheader className={headerStyles.drawerSubheader}>
          {intl.formatMessage({ id: "titulo" })}
        </ListSubheader>
        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            window.open("https://serviciosenlinea.sinac.go.cr/", "_blank")
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <PostAddIcon />
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SsP" })} />
        </ListItem>

        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            navigate("/santa-rosa")
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <PostAddIcon />
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SSR" })} />
        </ListItem>
        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            navigate("/naranjo")
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <PostAddIcon />
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SPN" })} />
        </ListItem>

        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            window.open("https://serviciosenlinea.sinac.go.cr/", "_blank")
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <PostAddIcon />
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SStMa" })} />
        </ListItem>

        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            navigate("/marino")
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <PostAddIcon />
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SsM" })} />
        </ListItem>

        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            window.location.href = "https://explore-horizontes.com/"
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <PostAddIcon />
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SH" })} />
        </ListItem>
        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            navigate("/murcielago")
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <PostAddIcon />
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SMu" })} />
        </ListItem>
        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            navigate("/sr-escuelas")
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <PostAddIcon />
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SREsc2" })} />
        </ListItem>
        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            navigate("/junquillal")
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <PostAddIcon />
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SsJ" })} />
        </ListItem>
      </List>
      <Divider />

      <ListSubheader className={headerStyles.drawerSubheader}>
        {intl.formatMessage({ id: "inft" })}
      </ListSubheader>

      <List>
        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            window.location.href =
              "https://www.acguanacaste.ac.cr/turismo/sector-pailas"
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <InfoIcon />{" "}
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SsP" })} />
        </ListItem>
        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            window.location.href = "https://explore-horizontes.com/"
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <InfoIcon />{" "}
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SH" })} />
        </ListItem>
        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            window.location.href =
              "https://www.acguanacaste.ac.cr/turismo/sector-santa-rosa/sector-santa-rosa"
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <InfoIcon />{" "}
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SSR" })} />
        </ListItem>
        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            window.location.href =
              "https://www.acguanacaste.ac.cr/turismo/sector-santa-rosa/playa-naranjo-sector-santa-rosa"
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <InfoIcon />{" "}
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SPN" })} />
        </ListItem>

        {
          <ListItem
            button
            className={headerStyles.drawerItem}
            onClick={() => {
              window.location.href =
                "https://www.acguanacaste.ac.cr/biodesarrollo/sector-marino"
            }}
          >
            <ListItemIcon className={headerStyles.drawerIcon}>
              <InfoIcon />{" "}
            </ListItemIcon>
            <ListItemText primary={intl.formatMessage({ id: "SsM" })} />
          </ListItem>
        }

        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            window.location.href =
              "https://www.acguanacaste.ac.cr/turismo/sector-santa-maria"
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <InfoIcon />{" "}
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SStMa" })} />
        </ListItem>

        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            window.location.href =
              "https://www.acguanacaste.ac.cr/turismo/sector-junquillal"
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <InfoIcon />{" "}
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SsJ" })} />
        </ListItem>

        <ListItem
          button
          className={headerStyles.drawerItem}
          onClick={() => {
            window.location.href =
              "https://www.acguanacaste.ac.cr/turismo/sector-murcielago"
          }}
        >
          <ListItemIcon className={headerStyles.drawerIcon}>
            <InfoIcon />{" "}
          </ListItemIcon>
          <ListItemText primary={intl.formatMessage({ id: "SMu" })} />
        </ListItem>
      </List>
    </div>
  )

  return (
    <header className={headerStyles.header}>
      <AppBar position="static" elevation={0} className={headerStyles.appBar}>
        <Container maxWidth="md">
          <Toolbar className={headerStyles.toolbar}>
            <Grid container alignItems="center">
              <Grid item xs={12} sm={8} md={8}>
                <Box className={headerStyles.brandRow}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    className={headerStyles.menuButton}
                    aria-label="Abrir menú"
                    onClick={toggleDrawer(anchor, true)}
                  >
                    <MenuIcon fontSize="large" />
                  </IconButton>
                  <Drawer
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}
                    PaperProps={{ className: headerStyles.drawerPaper }}
                  >
                    {list(anchor)}
                  </Drawer>
                  <Typography
                    variant="h6"
                    component="h1"
                    className={headerStyles.siteTitle}
                    title={siteTitle}
                  >
                    {intl.formatMessage({ id: "titulo" })}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={9} sm={3} md={3}>
                <Box className={headerStyles.languageWrap}>
                  <Language />
                </Box>
              </Grid>
              <Grid item xs={3} sm={1} md={1}>
                <Box className={headerStyles.logoWrap}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.acguanacaste.ac.cr/"
                  >
                    <img
                      className={headerStyles.logo}
                      src="/images/ACG-logo.png"
                      alt="Logo Área de Conservación Guanacaste, Fuente de Vida y Desarrollo"
                    />
                  </a>
                </Box>
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
